import React from 'react';
import { FadeIn, Button, CountdownTimer } from './Shared';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export const FinalCTA = () => {
  return <section className="py-10 md:py-16 px-4 bg-navy-800/50 relative overflow-hidden" data-id="element-86">
      <div className="absolute inset-0 bg-gradient-to-t from-navy-900 to-transparent" data-id="element-87"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-88">
        <FadeIn data-id="element-89">
          <h2 className="text-sm font-bold tracking-widest text-red-500 uppercase mb-6 drop-shadow-[0_0_8px_rgba(239,68,68,0.2)]" data-id="element-90">
            ⏰ ÚLTIMA OPORTUNIDAD
          </h2>
          <div className="mb-12" data-id="element-91">
            <CountdownTimer data-id="element-92" />
          </div>

          <div className="space-y-6 max-w-2xl mx-auto mb-12" data-id="element-93">
            <div className="bg-navy-900 p-6 rounded-2xl border border-navy-700 hover:border-yellow-400/30 transition-all" data-id="element-94">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-95">
                <div className="text-left" data-id="element-96">
                  <h4 className="text-xl font-serif font-bold text-white" data-id="element-97">
                    🌙 MEGAPACK NOCHES DE PAZ
                  </h4>
                  <div className="mt-1" data-id="element-98">
                    <span className="text-gray-400 line-through text-sm mr-2" data-id="element-99">
                      $61.000
                    </span>
                    <span className="text-2xl font-bold text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]" data-id="element-100">
                      $19.990 <span className="text-sm text-gray-300" data-id="element-101">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48588077203673:1" className="w-full md:w-auto" data-id="element-102">
                  → QUIERO MI MEGAPACK AHORA
                </Button>
              </div>
            </div>

            <div className="bg-gradient-to-r from-navy-800 to-navy-900 p-6 rounded-2xl border border-yellow-400/50 shadow-lg shadow-yellow-400/5" data-id="element-103">
              <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-104">
                <div className="text-left" data-id="element-105">
                  <h4 className="text-xl font-serif font-bold text-white" data-id="element-106">
                    🏆 MEGAPACK + RECONEXIÓN
                  </h4>
                  <div className="mt-1" data-id="element-107">
                    <span className="text-gray-400 line-through text-sm mr-2" data-id="element-108">
                      $79.000
                    </span>
                    <span className="text-2xl font-bold text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,0.3)]" data-id="element-109">
                      $27.990 <span className="text-sm text-gray-300" data-id="element-110">ARS</span>
                    </span>
                  </div>
                </div>
                <Button href="https://mundopractico.online/cart/48588081660121:1" className="w-full md:w-auto" data-id="element-111">
                  → QUIERO EL MEGAPACK + RECONEXIÓN
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-medium text-gray-300" data-id="element-112">
            <div className="flex items-center" data-id="element-113">
              <Lock className="w-4 h-4 mr-2 text-yellow-400" data-id="element-114" /> Pago 100% seguro
            </div>
            <div className="flex items-center" data-id="element-115">
              <Zap className="w-4 h-4 mr-2 text-yellow-400" data-id="element-116" /> Acceso en 5
              minutos
            </div>
            <div className="flex items-center" data-id="element-117">
              <ShieldCheck className="w-4 h-4 mr-2 text-yellow-400" data-id="element-118" /> Garantía
              7 días
            </div>
            <div className="flex items-center" data-id="element-119">
              <CreditCard className="w-4 h-4 mr-2 text-yellow-400" data-id="element-120" /> Mercado
              Pago
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};